
import React from "react";
import "./DeleteUser.css";
import ReactModal from "react-modal";
import { useGlobalContext } from "../../context";
import CloseIcon from "@mui/icons-material/Close";
import { deleteUser } from "../../api";

function DeleteUser({ getAllClientsData }) {
    
    const {
        openDeleteUser,
        setOpenDeleteUser,
        concretUser,
        setConcretUser
    } = useGlobalContext()
    
    const exitDelete = async () => {
        await setConcretUser();
        setOpenDeleteUser(false);
    }
    
    const deleteThisUser = async () => {
        const deleteData = await deleteUser(concretUser.facebookProfileId);
        if (deleteData) {
            getAllClientsData();
            exitDelete();
        }
    }
    
    return(
        <ReactModal
            isOpen = { openDeleteUser }
            onRequestClose = { exitDelete }
            style = {{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    zIndex: 300,
                },
                content: {
                    width: "90%",
                    top: "5px",
                    maxWidth: '580px',
                    maxHeight: "230px",
                    height: "85vh",
                    border: 'none',
                    margin: "auto",
                    left: "5%",
                    borderRadius: "10px",
                    background: 'white',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                    overflowY: "auto",
                }
            }}
        >
            <div style = {{
                width: "100%",
                height: "auto",
                display: window.innerWidth >= 620 ? "flex" : "none",
                alignItems: "center",
                justifyContent: "flex-end",
            }}>
                <CloseIcon 
                    style = {{ 
                        cursor: "pointer", 
                        color: "rgba(0,0,0,0.5)" 
                    }} 
                    onClick = { exitDelete }
                />
            </div>
            <div className = "deleteUserBox">
                <h4 className = "deleteUserHeatText">DELETE USER</h4>
                <span className = "deleteWindowMessage">Do You Want to Delete this User ?</span>
                <button className = "deleteUserBtn" onClick = { deleteThisUser }>Delete</button>
            </div>
        </ReactModal>
    )
}

export default DeleteUser


